import { Dispatch, SetStateAction } from "react";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SettingsAccordion } from "./CompanyCard-Setting-Accordion.partial";
import { MetaData } from "../../../Login/typings/login.types";
import {
  AdvancedBookingSettingsGroup,
  AdvancedBookingSettingsSetters,
  CheckinPolicyGroup
} from "../CompanyCard.types";
import { CompanyCardCheckinPolicyPerType } from "./CompanyCard-Setting-CheckinPolicyPerType.partial";

type CheckInPoliciesAccordionProps = {
  checkinEnabledGrp: CheckinPolicyGroup;
  setCheckinEnabledGrp: Dispatch<SetStateAction<CheckinPolicyGroup>>;
  newSetting: AdvancedBookingSettingsGroup;
  setNewSetting: AdvancedBookingSettingsSetters;
  newValues: MetaData;
  setNewValues: Dispatch<SetStateAction<MetaData>>;
};

export const CheckInPoliciesAccordion = ({
  checkinEnabledGrp,
  setCheckinEnabledGrp,
  newSetting,
  setNewSetting,
  newValues,
  setNewValues
}: Readonly<CheckInPoliciesAccordionProps>) => {
  const { t } = useTranslation();

  return (
    <SettingsAccordion title={t("Check-In Policies")}>
      <Stack spacing={2}>
        <CompanyCardCheckinPolicyPerType
          checkinEnabledGrp={checkinEnabledGrp}
          setCheckinEnabledGrp={setCheckinEnabledGrp}
          newSetting={newSetting}
          setNewSetting={setNewSetting}
          newValues={newValues}
          setNewValues={setNewValues}
        />
      </Stack>
    </SettingsAccordion>
  );
};
